"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSocketMessage = exports.validateSelectSlideMessage = exports.validatePongMessage = exports.validatePingMessage = exports.ITarget = exports.ICommandAction = void 0;
const validation_1 = require("@fmtk/validation");
var ICommandAction;
(function (ICommandAction) {
    ICommandAction["Create"] = "create";
    ICommandAction["Update"] = "update";
    ICommandAction["Delete"] = "delete";
    ICommandAction["BulkDuplicate"] = "bulk duplicate";
    ICommandAction["BulkDelete"] = "bulk delete";
    ICommandAction["RearrangeItems"] = "rearrange items";
    ICommandAction["MoveByOneIndex"] = "move by one index";
    ICommandAction["GoToSlide"] = "go to slide";
    ICommandAction["Ping"] = "ping";
    ICommandAction["Pong"] = "pong";
    ICommandAction["Connect"] = "connect";
    ICommandAction["PreparePresentingSession"] = "prepare presenting session";
    ICommandAction["DisconnectPresentingSession"] = "disconnect presenting session";
    ICommandAction["ClientHeartbeat"] = "client heartbeat";
})(ICommandAction = exports.ICommandAction || (exports.ICommandAction = {}));
var ITarget;
(function (ITarget) {
    ITarget["Deck"] = "deck";
    ITarget["Flashcard"] = "flashcard";
    ITarget["Bullet"] = "bullet";
    ITarget["User"] = "user";
    ITarget["Presentation"] = "presentation";
})(ITarget = exports.ITarget || (exports.ITarget = {}));
exports.validatePingMessage = (0, validation_1.properties)({
    type: (0, validation_1.is)(ICommandAction.Ping),
});
exports.validatePongMessage = (0, validation_1.properties)({
    type: (0, validation_1.is)(ICommandAction.Pong),
});
exports.validateSelectSlideMessage = (0, validation_1.properties)({
    type: (0, validation_1.is)('slide'),
    index: (0, validation_1.integer)(),
});
exports.validateSocketMessage = (0, validation_1.or)(exports.validatePingMessage, exports.validatePongMessage, exports.validateSelectSlideMessage);
//# sourceMappingURL=SocketMessage.js.map